module.exports = __webpack_public_path__ + "img/sixpackcarrier.4120703f.png";